import React from "react";
import "./Footer.css";
import { MailChimp } from "./MailChimp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <div className="container" style={{ background: "#0260A8" }}>
      <footer className="py-5">
        <div className="row">
          <div
            className="col-6 col-md-2 mb-3"
            style={{ width: "30%", marginRight: "2em" }}
          >
            <h5 style={{ paddingBottom: "1em" }}>About MSF</h5>
            <p>
              The MAX Scholarship Fund (MSF) awards well-rounded High School and
              Post Secondary students who are eager to make an impact, learn and
              create.
            </p>
            <p>
              {" "}
              They are students who have contributed to their communities and
              Canada at large, achieved above-average marks and are recognized
              by their peers, Muslim and non-Muslim alike.
            </p>
            <p>
            MSF is a registered charitable entity (Charitable Registration #: 780614681 RR 0001), and donors are eligible for a Charitable Tax Receipt.
            </p>
          </div>

          <div className="col-6 col-md-2 mb-3 footer-links">
            <h5 style={{ paddingBottom: "1em" }}>Helpful Links</h5>
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <a
                  href="/scholarships"
                  className="nav-link p-0 text-body-secondary"
                >
                  Scholarships
                </a>
              </li>
              <li className="nav-item mb-2">
                <a href="/sponsor" className="nav-link p-0 text-body-secondary">
                  Sponsor
                </a>
              </li>
              <li className="nav-item mb-2">
                <a
                  href="/past-winners"
                  className="nav-link p-0 text-body-secondary"
                >
                  Past Winners
                </a>
              </li>
              <li className="nav-item mb-2">
                <a
                  href="/financials"
                  className="nav-link p-0 text-body-secondary"
                >
                  Financials
                </a>
              </li>
              {/* <li className="nav-item mb-2">
                <a
                  href="/privacy-policy"
                  className="nav-link p-0 text-body-secondary"
                >
                  Website Terms and Conditions
                </a>
              </li> */}
              <li className="nav-item mb-2">
                <a href="/faq" className="nav-link p-0 text-body-secondary">
                  FAQ
                </a>
              </li>
              <li className="nav-item mb-2">
                <a href="/contact" className="nav-link p-0 text-body-secondary">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div
            className="col-md-5 offset-md-1 mb-3"
            style={{ marginLeft: "3em" }}
          >
            <h5 style={{ paddingBottom: "1em" }}>
              Subscribe to our newsletter
            </h5>
            <MailChimp />
            <div className="footer-icons">
              <a
                href="https://www.instagram.com/max.scholarshipfund/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  style={{ color: "#ffffff", height: "50px" }}
                />
              </a>
              <a
                href="https://www.facebook.com/max.scholarshipfund/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  style={{ color: "#ffffff", height: "50px" }}
                />
              </a>
              <a
                href="https://onemax.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/max-logo.png"
                  alt="OneMAX"
                  style={{ height: "50px", marginLeft: "10px" }}
                />
              </a>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
          <p>
            © 2025 MSF Inc. All rights reserved |{" "}
            <a href="/privacy-policy" className="website-terms-and-conditions">
              Website Terms and Conditions
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
